import React, { Fragment, useContext } from 'react';
import Blog from '../../component/Section/Blog';
import { useParams } from 'react-router';
import { SimpleShareButtons } from 'react-simple-share';

import { useAsync } from 'react-use';
import { getNewsDetail } from '../../core/services/news';

import { getImageFullPath } from '../../core';
import { getTopNews } from '../../core/services/news';

import { AppContext } from '../../core/Contexts/AppContext';

const DetailNews = (props) => {
  const { setTitle, setHeaderType, setImage } = useContext(AppContext);

  setTitle('სიახლეები');
  setImage('../../images/main-hero.png');
  setHeaderType(1);

  const params = useParams();

  const details = useAsync(() => getNewsDetail(params.id), [params.id]);

  const news = useAsync(getTopNews, []);

  let content = details?.value?.content;
  if (content) {
    content = content.replaceAll('/uploads/', 'https://msa.gov.ge/uploads/');
  }

  return (
    <Fragment>
      {!details.loading && (
        <section>
          <div className='container'>
            <div className='text-center mb-5'>
              <h3 className='bold font__size--32 text__32-1024 text-uppercase mb-3'>
                {details.value.title}
              </h3>
            </div>

            <div className='position-relative'>
              <div className='wrapper__sosmed-left d-none d-md-block'>
                <SimpleShareButtons
                  url={window.location.href}
                  whitelist={['Facebook', 'Twitter', 'LinkedIn']}
                  size='30px'
                />
              </div>

              <div className='row justify-content-center'>
                <div className='col-md-10 col-lg-8'>
                  <img
                    src={getImageFullPath(
                      `uploads/news/${details.value.file_name}`
                    )}
                    className='w-100 images__blog-head mb-3'
                    alt=''
                  />
                  <div className='d-flex align-items-center mb-3'>
                    <h5 className='mb-0 semi-bold font__size--14 text__14-1024 text-uppercase color__blue'>
                      სიახლეები
                    </h5>
                    <span className='font__size--14 text__14-1024 text-uppercase color__gray-1 px-2'>
                      |
                    </span>
                    <h5 className='mb-0 semi-bold font__size--14 text__14-1024 text-uppercase color__gray-1'>
                      {details.value.date}
                    </h5>
                  </div>
                  <p
                    className='normal font__size--16 text__16-1024'
                    dangerouslySetInnerHTML={{
                      __html: content,
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      <div className='blog-sec'>
        {!news.loading && <Blog blog={news.value} title={'სიახლეები'} />}
      </div>
    </Fragment>
  );
};

export default DetailNews;
